// extracted by mini-css-extract-plugin
export default {"root":"_1VrOU","warning":"wUVhY","error":"_2KW_f","success":"_3ntdz","note":"_3eYUQ","brand":"_1--px"};